module.exports = __webpack_public_path__ + "img/icon-cooperate.10ae8b68.svg";